const routes = [
    {
      path: '/',
      name: 'home',
      // component: resolve => require(['../pages/vote'], resolve),
      component: () => import('@/pages/vote')
    },
    {
      path: '/vote',
      name: 'Vote',
      // component: resolve => require(['../pages/vote'], resolve),
      component: () => import('@/pages/vote')
    },
    {
      path: '/ai',
      name: 'AIIndxe',
      // component: resolve => require(['../pages/AIIndxe'], resolve),
      component: () => import('@/pages/AIIndxe')
    },
    {
      path: '/ailist',
      name: 'AIRecommended',
      // component: resolve => require(['../pages/AIRecommended'], resolve),
      component: () => import('@/pages/AIRecommended')
    },{
      path: '/target',
      name: 'Target',
      // component: resolve => require(['../pages/Target'], resolve),
      component: () => import('@/pages/Target')
    },
    {
      path: '/noequipment',
      name: 'NoEquipmentPlan',
      // component: resolve => require(['../pages/NoEquipmentPlan'], resolve),
      component: () => import('@/pages/NoEquipmentPlan')
    },
    {
      path: '/equipment',
      name: 'EquipmentPlan',
      // component: resolve => require(['../pages/EquipmentPlan'], resolve),
      component: () => import('@/pages/EquipmentPlan')
    },
    {
      path: '/course',
      name: 'Course',
      // component: resolve => require(['../pages/Course'], resolve),
      component: () => import('@/pages/Course')
    },
    // {
    //   path: '/challenge',
    //   name: 'Challenge',
    //   component: resolve => require(['../pages/Challenge'], resolve),
    // },
    // {
    //   path: '/challenge_goal',
    //   name: 'ChallengeGoal',
    //   component: resolve => require(['../pages/challenge/goal'], resolve),
    // },
    {
      path: '/challenge',
      name: 'ChallengeBase',
      // component: resolve => require(['../pages/challenge/base'], resolve),
      component: () => import('@/pages/challenge/base')
    },
    {
      path: '/challenge_pro',
      name: 'ChallengePro',
      // component: resolve => require(['../pages/challengePro/index'], resolve),
      component: () => import('@/pages/challengePro/index')
    },
    {
      path: '/challenge_list',
      name: 'ChallengeList',
      // component: resolve => require(['../pages/ChallengeList'], resolve),
      component: () => import('@/pages/ChallengeList')
    },
    {
      path: '/challenge_managent',
      name: 'ChanllengeManagent',
      // component: resolve => require(['../pages/ChanllengeManagent'], resolve),
      component: () => import('@/pages/ChanllengeManagent')
    },
    {
      path: '/challenge_rule',
      name: 'ChallengeRule',
      // component: resolve => require(['../pages/ChallengeRule'], resolve),
      component: () => import('@/pages/ChallengeRule')
    },
    {
      path: '/feedback',
      name: 'AppFeedback',
      // component: resolve => require(['../pages/feedback/AppFeedback'], resolve),
      component: () => import('@/pages/feedback/AppFeedback')
    },
    {
      path: '/success',
      name: 'Success',
      // component: resolve => require(['../pages/Success'], resolve),
      component: () => import('@/pages/Success')
    },
    {
      path: '/redeem',
      name: 'Redeem',
      // component: resolve => require(['../pages/Redeem'], resolve),
      component: () => import('@/pages/Redeem')
    },
    {
      path: '/topic',
      name: 'Topic',
      // component: resolve => require(['../pages/Topic/template'], resolve),
      component: () => import('@/pages/Topic/template')
    },
    {
      path: "/world_tour/topic",
      name: "WorldTourTopic",
      // component: (resolve) => require(["../pages/Topic/worldTour"], resolve),
      component: () => import('@/pages/Topic/worldTour')
    },
    {
      path: '/newyear',
      name: 'Newyear',
      // component: resolve => require(['../pages/landingPage/newYear'], resolve),
      component: () => import('@/pages/landingPage/newYear')
    },
    {
      path: '/anniversary/newyear',
      name: 'anniversary',
      // component: resolve => require(['../pages/celebration/first'], resolve),
      component: () => import('@/pages/celebration/first')
    },
    {
      path: '/report',
      name: 'report',
      // component: resolve => require(['../pages/report/index'], resolve),
      component: () => import('@/pages/report/index')
    },
    {
      path: '/workout_overview',
      name: 'workoutOverview',
      component: resolve => require(['../pages/workoutOverview/index'], resolve),
    },
    {
      path: '/points_mall',
      name: 'pointsMall',
      component: () => import('@/pages/pointsMall/index')
    },
    {
      path: '/points_mall_order',
      name: 'pointsMallOrder',
      component: () => import('@/pages/pointsMall/order')
    },
    {
      path: '/points_mall_order_address',
      name: 'pointsMallOrderAddress',
      component: () => import('@/pages/pointsMall/address')
    },
    {
      path: '/points_mall_exchange_success',
      name: 'pointsMallExchangeSuccess',
      component: () => import('@/pages/pointsMall/exchangeSuccess')
    },
    {
      path: '/points_mall_how_claim',
      name: 'pointsMallHowClaim',
      component: () => import('@/pages/pointsMall/howClaim')
    },
    {
      path: '/points_mall_gift_records',
      name: 'pointsMallGiftRecords',
      component: () => import('@/pages/pointsMall/giftList')
    },
    {
      path: '/points_mall_invite_success',
      name: 'pointsMallInviteSuccess',
      component: () => import('@/pages/pointsMall/inviteSuccess')
    },
    {
      path: '/points_mall_order_records',
      name: 'pointsMallOrderRecords',
      component: () => import('@/pages/pointsMall/orderList')
    },
    {
      path: '/points_mall_order_detail',
      name: 'pointsMallOrderDetail',
      component: () => import('@/pages/pointsMall/orderDetail')
    },
    {
      path: '/points_mall_order_course_detail',
      name: 'pointsMallOrderCourseDetail',
      component: () => import('@/pages/pointsMall/orderCourseDetail')
    },
    {
      path: '/support_equipment',
      name: 'supportEquipment',
      component: resolve => require(['../pages/supportEquipment/index'], resolve),
    },
    {
      path: '/support_equipment/:type',
      name: 'supportEquipmentDetail',
      component: resolve => require(['../pages/supportEquipment/detail'], resolve),
    },
    { 
      path: '*', 
      // component: resolve => require(['../pages/vote'], resolve), 
      component: () => import('@/pages/vote')
    }
  ]
  export default routes



// WEBPACK FOOTER //
// ./src/router/index.js